import {useRef, useState, useEffect} from "react"
//https://dev.to/ameersami/detect-if-a-react-component-is-out-of-viewport-bounds-2ij1
export const useOutOfBounds = (props) => {
    const _initState = {
        top: false,
        bottom: false,
        left: false,
        right: false
    }
    const componentRef = useRef()
    const [isOutOfBounds, setIsOutOfBounds] = useState(Object.assign({}, _initState))
    const [firstRun, setFirstRun] = useState(true)

    const getBounds = useRef(()=> {
        if(!componentRef.current) return
        const rect = componentRef.current.getBoundingClientRect()
        const windowWidth = Math.min(document.documentElement.clientWidth, window.innerWidth)
        const windowHeight = Math.min(document.documentElement.clientHeight, window.innerHeight)
        let directions = Object.assign({}, _initState)
        //these are inverted values because semantics in CSS
        if(rect.top < 0) {
            directions.bottom = true//rect.top < 0
        }
        if(rect.bottom > windowHeight) {
            directions.top = true//windowHeight - rect.bottom < 0
        }
        if(rect.left < 0) {
            directions.right = true//rect.left < 0
        }
        if(rect.right > windowWidth) {
            directions.left = true//windowWidth - rect.right < 0
        }
        if(isOutOfBounds !== directions) setIsOutOfBounds(directions)
        // if (isOutOfBounds.top !== directions.top || isOutOfBounds.bottom !== directions.bottom || isOutOfBounds.left !== directions.left || isOutOfBounds.right !== directions.right) {
        //     setIsOutOfBounds(directions)
        // }
    })

    // useLayoutEffect(() => {
    //     function updateSize() {
    //         if(!firstRun) {
    //             setIsOutOfBounds(Object.assign({}, _initState))
    //             setFirstRun(false)
    //         }
    //         setTimeout(()=>{
    //             getBounds.current()
    //         }, 200)
    //     }
    //     window.addEventListener('resize', updateSize)
    //     updateSize()
    //     return () => {
    //         componentRef.current = null
    //         window.removeEventListener('resize', updateSize)
    //     }
    // }, [])

    function parsePositionClasses(array){
        //first className defines how this thing works
        const firstClass = componentRef.current?.classList[0] || ""
        let classArr = []
        Object.keys(array).forEach((a, i)=>{
            if(array[a] === true) classArr.push(firstClass + "-" + a)
        })
        if(classArr.length < 1) return ""
        return classArr.join(" ")
    }
    // const mutationObserverCallback = (mutationRecord, observer) => {
    //    // setIsOutOfBounds(getBounds(componentRef))
    //     //if(firstRun)
    //     setIsOutOfBounds(getBounds.current())
    //     //firstRun = false
    // }
    // const observer = new MutationObserver(mutationObserverCallback)
    // useEffect(() => {
    //     if (componentRef.current) {
    //         observer.observe(componentRef.current, { attributes: true, childList: true, subtree: true })
    //     }
    //     return () => observer.disconnect()
    // }, [componentRef, observer])

    //checks if element itself has resized
    const resizeObserver = new ResizeObserver(() => {
        // Do what you want to do when the size of the element changes
        if (!componentRef.current) return
        if(firstRun) getBounds.current()
        setFirstRun(false)
    })
    useEffect(() => {
        if (!componentRef.current) return
        resizeObserver.observe(componentRef.current)
        return () => resizeObserver.disconnect()// clean up
    }, [resizeObserver])

    return [componentRef, parsePositionClasses(isOutOfBounds)]
}

export function useOutsideCallback(ref, callback) {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                callback()
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [ref, callback])
}

export function addAText(amount, str, char){
    if(amount == null) amount = 0
    let text =  amount + ' ' + str
    if(amount === 1) return text
    text += (amount > 1 || amount === 0 ? char : '')
    return text
}